/**
 * @typedef {Object} EngagementInsightSection
 * @property {string} name
 * @property {string} narrative
 * @property {number[]} note_ids
 */

/**
 * @typedef {Object} EngagementInsightContent
 * @property {string} overview
 * @property {EngagementInsightSection[]} sections
 * @property {string} source_coverage
 */

export const INSIGHT_SECTION_DEFINITIONS = Object.freeze([
    { name: "recent_developments", label: "Recent developments", suggested: false },
    { name: "existing_actions", label: "Existing actions", suggested: false },
    { name: "items_needing_review", label: "Items needing review", suggested: false },
    { name: "ai_suggested_next_steps", label: "Suggested next steps", suggested: true },
]);

export const emptyInsightContent = () => ({
    overview: "",
    sections: INSIGHT_SECTION_DEFINITIONS.map(definition => ({
        name: definition.name,
        narrative: "",
        note_ids: [],
    })),
    source_coverage: "",
});

export const narrativeWithoutCitationMarkers = (narrative) => String(narrative || "")
    .replace(/\s*\[\d+\]/g, "")
    .replace(/\s+([,.;:!?])/g, "$1");

export const copyInsightContent = (content) => {
    const copy = JSON.parse(JSON.stringify(content));
    return {
        ...copy,
        sections: copy.sections.map(section => ({
            ...section,
            narrative: narrativeWithoutCitationMarkers(section.narrative),
        })),
    };
};

export const insightSection = (content, name) => content.sections.find(section => section.name === name);
